<template>
  <div id="app">
    <router-view></router-view>

    <div v-if="loading" class="loader">
      <div class="">
            <img src="@/assets/images/logo-sm.png" alt="" class="profile-wid-img" />
        </div>
      <b-spinner variant="info" label="Loading..."></b-spinner>
      <p>Loading getting information together...</p>
    </div>
  </div>
</template>

<script>
import { getUserTheme, watchTheme } from "./helpers/theme";
import { layoutMethods } from "@/state/helpers";

export default {
  name: 'App',
  data() {
    return {
      loading: false
    }
  },
  created() {

        this.initializeTheme();

    const user = localStorage.getItem('ENSPSID');

    if (user) {
      this.loading = true;
      const promises = [
        this.$store.dispatch('user/getPermissions'),
        // this.$store.dispatch('school/getSchools'),
        // this.$store.dispatch('school/getCampusses'),
        // this.$store.dispatch('school/getSubSections'),
        // this.$store.dispatch('school/getPrograms'),
        // this.$store.dispatch('school/getLevels'),
        // this.$store.dispatch('school/getAcademicYears'),
        this.$store.dispatch('authfack/getProfile')
      ];

      Promise.all(promises)
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    }
  },
  methods:{

    ...layoutMethods,
    initializeTheme() {
      const userTheme = getUserTheme();
      this.changeMode(userTheme);
      document.documentElement.setAttribute("data-layout-mode", userTheme);

      watchTheme((newTheme) => {
        this.changeMode(newTheme);
        document.documentElement.setAttribute("data-layout-mode", newTheme);
      });
    },
  }
}
</script>

<style>
.loader {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh; /* Ensure loader covers full screen */
}
</style>
